import { render, staticRenderFns } from "./ManageLogistic.vue?vue&type=template&id=e7e5f6ca&"
import script from "./ManageLogistic.vue?vue&type=script&lang=js&"
export * from "./ManageLogistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports